module.exports = __webpack_public_path__ + "static/media/pass.3030eedc.svg";